import React from 'react'
import { Link } from 'react-router-dom'
import Button from '../../../components/forms/blackfillButton'
import RedButton from '../../../components/forms/redButton'

const Item = ({Obj,Delete}) => {
  return (
    <div className='form_item_row_container discription'>
      <div className='form_item_row_container_itemfull' style={{width:'15%'}}>
        <p>{Obj.name}</p>
      </div>
      <div className='form_item_row_container_item' style={{width:'15%'}}>
        <p>{Obj.type}</p>
      </div>
      <div className='form_item_row_container_item' style={{width:'35%'}}>
        <p>{Obj.url}</p>
      </div>
      <div className='form_item_row_container_item' style={{width:'15%'}}>
        <p>{Obj.parent}</p>
      </div>
      <div className='form_item_row_container_item' style={{width:'20%',display:"flex",justifyContent:"space-between"}}>
        <Link to={'edit/'+Obj.id}>
          <Button Value={'Edit'}/>
        </Link>
        <RedButton Value={'Delete'} Action={()=>{Delete(Obj.id)}}/>
      </div>
    </div>
    
  )
}

export default Item
